import { skipToken, useQuery } from "@tanstack/react-query";
import { useTRPC } from "@/trpc";
import type { RouterOutputs } from "@/trpc";

export type AdHocOrganizationWageSet =
  RouterOutputs["timeEntry"]["getOrganizationWageSetsForAdHocEntry"][number];

/** The provider's wage sets at a business unit for work starting at `at`. */
export function useOrganizationWageSetsForAdHocEntry(
  input: { organizationBusinessUnitId: string; at: Date } | undefined,
) {
  const trpc = useTRPC();

  const { data, isLoading } = useQuery(
    trpc.timeEntry.getOrganizationWageSetsForAdHocEntry.queryOptions(
      input ?? skipToken,
    ),
  );

  return { organizationWageSets: data ?? [], isLoading };
}
